import React, { useState, useEffect, useContext } from "react";
import { ScenariosIcons } from "./ScenariosIcons";
import Carousel from "react-elastic-carousel";
import { ModalComp, MusicPlayer } from "../../shared";
import { LeftSection } from "../../context/LeftSectionContext";
import { scenariosList } from "../../api";
import Cookies from "js-cookie";
import { ScenariosModal } from "../../shared/Scenarios/ScenariosModal";
import { AddScenario } from "../../shared/Scenarios";
import { useTranslation } from "react-i18next";

const Scenarios = () => {
  const { t } = useTranslation();
  const breakPoints = [
    { width: 400, itemsToShow: 5 },
    { width: 550, itemsToShow: 9 },
    // { width: 850, itemsToShow: 12 },
    // { width: 1000, itemsToShow: 9 },
  ];

  const [openScenarioModal, setOpenScenarioModal] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const { show } = useContext(LeftSection);
  const [scenario, setScenario] = useState({});
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const toggleScenarioModal = (scenario) => {
    setOpenScenarioModal(!openScenarioModal);
    setScenario(scenario);
  };
  //   *******************
  const token = Cookies.get("token");
  const [scenarios, setScenarios] = useState([]);
  const [openAddScenarioModal, setOpenAddScenarioModal] = useState(false);
  const toggleAddScenario = () => {
    setOpenAddScenarioModal(!openAddScenarioModal);
  };
  useEffect(() => {
    const token = Cookies.get("token");

    scenariosList(token)
      .then((result) => {
        setScenarios(result.data.data);
      })
      .catch((error) => {
        if (error.response.status === 403) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
        // console.log("error scenario", error);
      });
    // console.log(openScenarioModal);
  }, [openScenarioModal]);

  const openMusicPlayer = () => {
    // if (!isPhone) {
    //     show("music");
    // } else {
    //     toggleMusic();
    // }
    // if (isPhone && window.orientation === 0) {
    //   toggleMusic();
    // } else {
    //   show("music");
    // }
  };
  useEffect(() => {
    scenariosList(token)
      .then((result) => {
        setScenarios([
          ...result.data.data,
          { title: t("افزودن"), icon: "icon-plus" },
        ]);
      })
      .catch((error) => {});
  }, [openScenarioModal, openAddScenarioModal]);

  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 576) {
      setIsPhone(true);
    }
  }, []);

  return (
    <>
      <ModalComp
        modal={openScenarioModal}
        toggle={toggleScenarioModal}
        component={
          <ScenariosModal
            scenario={scenario}
            closeModal={setOpenScenarioModal}
          />
        }
      />
      <ModalComp
        modal={openAddScenarioModal}
        toggle={toggleAddScenario}
        component={<AddScenario />}
      />
      {/* <div>
        <div className="d-flex align-items-center justify-content-between w-100">
          <p className="m-0">سناریو ها</p>
          <i
            className="icon-ellipsis-vert cursor"
            style={{ fontSize: "18px" }}
          ></i>
        </div>
      </div> */}

      {/* <div className="d-flex text-center my-1" style={{ height: '100px' }}> */}
      <div className="d-flex text-center my-1 " style={{ height: "100px" }}>
        <Carousel itemsToScroll={1} breakPoints={breakPoints}>
          {scenarios.length ? (
            scenarios.map((scenario, index) => {
              return (
                <ScenariosIcons
                  name={scenario.title}
                  type={scenario.icon.slice(5)}
                  icon={scenario.icon}
                  key={index}
                  toggleScenarioModal={() => {
                    scenario.icon === "icon-plus"
                      ? toggleAddScenario()
                      : toggleScenarioModal(scenario);
                  }}
                />
              );
            })
          ) : (
            <p>{t("در حال حاضر سناریویی تعریف نشده است")}</p>
          )}
        </Carousel>
      </div>
    </>
  );
};

export { Scenarios };
